import { render, staticRenderFns } from "./MeuPerfil.vue?vue&type=template&id=356bcb1a&scoped=true"
import script from "./MeuPerfil.vue?vue&type=script&lang=js"
export * from "./MeuPerfil.vue?vue&type=script&lang=js"
import style0 from "./MeuPerfil.vue?vue&type=style&index=0&id=356bcb1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356bcb1a",
  null
  
)

export default component.exports